"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxWithReason = void 0;
const react_1 = __importStar(require("react"));
const commons_v2_checkbox_1 = require("@experta/commons-v2.checkbox");
const commons_v2_input_1 = require("@experta/commons-v2.input");
const utils_1 = require("./utils");
require("./checkbox-with-reason.css");
/**
 * Main component.
 * @name CheckboxWithReason
 * @param {CheckboxWithReasonProps}
 * @returns {<CheckboxWithReason />}
*/
exports.CheckboxWithReason = (0, react_1.forwardRef)(({ title, description, showReasonTextInput = true, returnInfo, requireReason, requiredCheckBox }, ref) => {
    const [localData, setLocalData] = (0, react_1.useState)({
        reason: '',
        checkboxValue: false
    });
    const [localDataErrors, setLocalDataErrors] = (0, react_1.useState)([]);
    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === "reason") {
            setLocalData(prev => (Object.assign(Object.assign({}, prev), { reason: value })));
            return;
        }
        if (name === "checkboxValue") {
            setLocalData(prev => (Object.assign(Object.assign({}, prev), { checkboxValue: !prev.checkboxValue })));
            return;
        }
    };
    (0, react_1.useImperativeHandle)(ref, () => ({
        validateData: () => {
            var _a;
            let result = (0, utils_1.validateData)(Object.assign(Object.assign({}, localData), { requiredCheckbox: Boolean(requiredCheckBox), requiredReason: Boolean(requireReason) }));
            setLocalDataErrors([...result.errorsMessages]);
            return ((_a = result.errorsMessages) === null || _a === void 0 ? void 0 : _a.length) === 0;
        }
    }), [localData]);
    (0, react_1.useEffect)(() => {
        returnInfo(localData);
    }, [localData]);
    return (react_1.default.createElement("div", { className: "checkbox-with-reason", "data-testid": "checkbox-reason-element" },
        react_1.default.createElement("div", { className: "check-box" },
            react_1.default.createElement(commons_v2_checkbox_1.Checkbox, { checked: localData.checkboxValue, onChange: handleChange, name: "checkboxValue" })),
        react_1.default.createElement("div", { className: "title", dangerouslySetInnerHTML: { __html: title } }),
        react_1.default.createElement("div", { className: "description", dangerouslySetInnerHTML: { __html: description } }),
        (showReasonTextInput && localData.checkboxValue) && (react_1.default.createElement("div", { className: "reason-input" },
            react_1.default.createElement(commons_v2_input_1.Input, { type: "textArea", label: "Motivo", name: "reason", onChange: handleChange, required: requireReason })))));
});
__exportStar(require("./utils"), exports);
//# sourceMappingURL=checkbox-with-reason.js.map